import React from 'react';

export default class CheckboxButton extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => this.props.onClick(this.props.index)

    render() {
        return (
            <li>
                <input type="checkbox" id={ "cboxBton" + this.props.valor } value={ this.props.valor } checked={ this.props.ativo } onChange={ this.handleClick }/>
                <label htmlFor={ "cboxBton" + this.props.valor }>{ this.props.valor }</label>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/CheckboxButton.js